import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Features, ModuleNames } from '../../../common/model/account-definition';
import { UserAccountService } from '../../../common/service/user-account.service';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { rentalObjectCommand } from '../../command/rental-object.command';
import { RentalObjectCategory } from '../../model/const/enums';
import { CreateContractCommandHandler } from '../../service/command/create-contract-command-handler.service';
import { VacantCommandHandlerResolver } from '../../service/command/vacant-command-handler-resolver.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { VacantRentalObjectService } from '../../service/data/vacant-period.service';
import { VacantRentalObjectComponentBase } from '../base/vacant-rental-object.base';

@Component({
    selector: 'app-vacant-dwelling',
    templateUrl: './vacant-dwelling.component.html',
    styleUrls: ['./vacant-dwelling.component.scss'],
    providers: [CreateContractCommandHandler, VacantCommandHandlerResolver, { provide: 'category', useValue: RentalObjectCategory.Dwelling }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VacantDwellingComponent extends VacantRentalObjectComponentBase {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    messageService: MessageService,
    navigation: NavigationService,
    service: VacantRentalObjectService,
    dispatcher: CommandDispatcher,
    handlerResolver: VacantCommandHandlerResolver,
    private _accountService: UserAccountService
  ) {
    super(columnDefinitionService, messageService, navigation, service, dispatcher, handlerResolver);

    this.AddSubscription(
      this._accountService.current.subscribe({
        next: account => {
          if (
            account.hasAccess(ModuleNames.Letting, Features.Letting_HomeQ) ||
            account.hasAccess(ModuleNames.Letting, Features.Letting_DhMarket)
          ) {
            this.menuDefinition.push(new MenuItemDefinition('RENTAL_OBJECT.COMMAND.ADVERTISE', rentalObjectCommand.advertise));
          }
        },
      })
    );
  }

  protected get category(): RentalObjectCategory {
    return RentalObjectCategory.Dwelling;
  }

  onRowClicked(e: { context: any; event: any }): void {
    this.navigation.navigate(['vacantdwelling', 'edit', e.context.rentalObjectId], null, e.event.ctrlKey);
  }
}
